<!--
@Author: Calvin Green <calvin>
@Date:   2021-10-26T10:53:15+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-05-16T15:45:12+02:00
@Copyright: Diversitude 2021
-->



<template>
    <div>
        <!-- <b-alert :show="true">HEY! Do the multi upload stuff</b-alert> -->
        <b-card>
            <span style="font-size: 2rem; font-weight: 500;">{{step_data.step_name}}</span>
            <form-plugin
            :viewFile="clientMediaFile(step_uid)"
            :step="step_data.render_order"
            @hasLoaded="has_form_loaded = true"
            @downloadFile=processFileDownload
            @uploaderData="processUpload"
            @formDataUpdated="updateFormData"
            :viewData="step_form_data"
            :uid="step_uid"></form-plugin>

            <b-button v-if="has_form_loaded" @click="save" variant="success">
            Save</b-button>
        </b-card>
        <DownloadModal :isImage="true" v-if="showDownloadModal == true" />
    </div>
</template>

<script>
import DownloadModal from '@/components/client/downloadModal.vue'
import Uploader from 'simple-uploader.js'
//eslint-disable-next-line
import _ from 'lodash'
import { licenseAppState, licenseAppMethods } from '@/state/helpers'

export default {
    components:{
        DownloadModal
    },
    data:() => ({
        showDownloadModal: false,
        has_form_loaded: false,
        current_form_data: {},
        params:{},
        hasSaved: false,
    }),
    computed:{
        ...licenseAppState,
        step_form_data(){
            return this.step_data.spreadify_views[0].form_data
        },
        step_uid(){
            return this.step_data.spreadify_views[0].spreadify_uid
        },
    },
    methods:{
        ...licenseAppMethods,
        updateFormData(newData){
            //*event fired from <form-plugin>
            this.current_form_data = newData.data;
        },
        processUpload(file){
            //* Uploader event method
            let storage = window.localStorage;
            let AUTH_TOKEN = storage.getItem('x_token');
            let uploader = new Uploader({
                target: process.env.VUE_APP_API_BASEURL + 'api/licenseapp/uploadmedia',
                headers: {
                    'Authorization': 'Bearer ' + AUTH_TOKEN,
                },
                query:{/* '612f6171f003b',*/
                    step_id : this.step_data.id,
                    spreadify_uid : this.step_uid,
                    key : 'client_logo',
                },
                testChunks: false,
                fileParameterName: 'file', //Set the upload post param which will contain the binary payload
                singleFile: true, //Limit upload to one file
            });
            //eslint-disable-next-line
            uploader.on('fileComplete', function (rootFile) {
                console.log('fileComplete')
            });
            //eslint-disable-next-line
            uploader.on('fileAdded', function (file, event) {
                console.log('fileAdded', file);
            });

            this.$nextTick(()=>{
                uploader.addFile(file);
                this.$nextTick(()=>{
                    uploader.upload();
                })
            });
        },
        processFileDownload(params){
            this.showDownloadModal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('downloadModal');
                this.$root.$once('bv::modal::hidden',(event)=>{
                    if(event.type == 'hidden' && event.componentId == 'downloadModal'){
                        this.showDownloadModal = false;
                    }
                })
                this.getDownloadLink(params)
                .then(response => {
                    this.$eventHub.$emit('setDownloadUrl', response);
                })
            })
        },
        clientMediaFile(uid){
            let files = [];
            this.step_data.client_uploads.forEach((file) => {
                if(file.spreadify_uid == uid){
                    files.push(file);
                }
            });
            return files;
        },
        save(){
            console.log('Selected Save')
        }
    },
    mounted(){
        this.params = {
            step_id: this.step_data.id,
            form_data:[],
        }
        /*this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'Saved Configuration', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
        setTimeout(()=>{
            this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'Saved Configuration', customClass: {     popup: 'info-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
        }, 3000);
        setTimeout(()=>{
            this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'error', title:'Saved Configuration', customClass: {     popup: 'error-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
        }, 6000);*/

    },
    beforeDestroy(){
        //*Fetch new data for the status bar and project timeline table
        if(this.hasSaved){
            this.loadAppData();
        }
    }
}
</script>

<style>

</style>
